import React, { useEffect } from "react";
import Router from "./routes";
import { useDispatch } from "react-redux";
import { login, logout } from "./redux/reducer/LoginReducer";
import ErrorPopup from "./shared/Models/ErrorPopup";
import SuccessPopup from "./shared/Models/SuccessPopup";
import Loader from "./shared/Loader/Loader";
import CryptoJS from "crypto-js";

function App() {
  const dispatch = useDispatch();

  useEffect(() => {
    checkLogin()
  }, [])

  const checkLogin = async () => {
    const value = localStorage.getItem('userLogin');
    const decryptValue = CryptoJS.AES.decrypt(value, "B!gn|e@n").toString(CryptoJS.enc.Utf8);
    if (decryptValue && decryptValue === 'bignlean') {
      dispatch(login());
    }
    else {
      dispatch(logout());
    }
  }

  return (
    <div>
      <Router />
      <ErrorPopup />
      <Loader />
      <SuccessPopup />
    </div>
  );
}

export default App;
